import React from "react";
import { useRouteError, useRouteLoaderData } from "react-router-dom";
import { Result, Button } from "antd";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";
import {
  AppLayout,
  NavButton,
  TopNavigation,
  SideNavigation,
  SideActions,
} from "~/components";
import { TourProvider, TourManager } from "~/components/Tour";
import {
  AppGuideProvider,
  AppGuideModal,
  TOTAL_SECTIONS,
} from "~/components/AppGuide";
import * as APITypes from "~/API";
import type { MainLayoutLoaderData } from "./MainLayout";

export const MainLayoutErrorBoundary: React.FC = () => {
  const { t } = useTranslation();
  const error = useRouteError();
  const layoutData = useRouteLoaderData("main") as MainLayoutLoaderData | undefined;
  const smallScreen = useMediaQuery("(max-width: 465px)");

  console.error("An error occurred on this page", error);

  const userHasOrganization =
    layoutData?.isAuthenticated &&
    layoutData?.ownerType === APITypes.OwnerType.Organization;

  const pageStyling = {
    flex: 1,
    padding: smallScreen ? "0.5rem" : "2rem",
  };

  return (
    <AppGuideProvider totalSections={TOTAL_SECTIONS}>
      <TourProvider>
        <TourManager />
        <AppGuideModal />
        <AppLayout
          TopNavigation={<TopNavigation />}
          SideNavigation={
            <SideNavigation userHasOrganization={!!userHasOrganization} />
          }
          SideAction={<SideActions />}
          PageContent={
            <div style={pageStyling}>
              <Result
                status="500"
                title="500"
                subTitle={t("Sorry_something_went_wrong")}
                extra={
                  <NavButton to="/" type="primary">
                    Back Home
                  </NavButton>
                }
              />
            </div>
          }
        />
      </TourProvider>
    </AppGuideProvider>
  );
};
